import {booleanAttribute, Component, Input, OnInit} from '@angular/core';
import {combineLatest, Observable, of} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {AuthUserService} from '../../app-services/auth-user.service';
import {BaseUnsubscribeComponent} from '../base-unsubscribe.component';

@Component({
  selector: 'cmn-auth-user-name',
  templateUrl: './auth-user-name.component.html',
  styleUrl: './auth-user-name.component.scss',
  imports: [
    AsyncPipe,
    MatIcon,
    MatTooltip,
    TranslateModule
  ]
})
export class AuthUserNameComponent extends BaseUnsubscribeComponent implements OnInit {

  /** Круг с инициалами; отключается там, где хост уже обозначает пользователя (шапка меню). */
  @Input({transform: booleanAttribute}) showAvatar = true;

  /** Имя рядом с аватаром; на узких экранах остаётся только аватар. */
  @Input({transform: booleanAttribute}) showName = true;

  userName$: Observable<string> = of();
  initials$: Observable<string> = of();

  /** Имя реального пользователя, когда работа идёт под другим; иначе пустая строка. */
  supervisorName$: Observable<string> = of();

  constructor(private readonly authUserService: AuthUserService) {
    super()
  }

  ngOnInit(): void {
    this.userName$ = this.authUserService.currentUser$
      .pipe(
        takeUntil(this.destroy),
        map(user => user?.name || '')
      );
    this.initials$ = this.userName$.pipe(map(name => AuthUserNameComponent.toInitials(name)));

    const realUserName$ = this.authUserService.currentRealAuthUser().pipe(
      takeUntil(this.destroy),
      map(user => user?.name || '')
    );
    this.supervisorName$ = combineLatest([this.userName$, realUserName$]).pipe(
      map(([userName, realUserName]) => realUserName !== userName ? realUserName : '')
    );
  }

  private static toInitials(name: string): string {
    const words = name.trim().split(/\s+/).filter(word => word.length > 0);
    if (words.length === 0) {
      return '';
    }
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }
    return (words[0][0] + words[1][0]).toUpperCase();
  }
}
